// extracted by mini-css-extract-plugin
export default {"inputWrapper":"style_inputWrapper__3qlYZ","inputBox":"style_inputBox__C7+N1","label":"style_label__XhoEx"};